/**
 * The external dependencies.
 */
import {createAction} from 'redux-actions';

export const qualityGetTasks = createAction(
    'quality/get-tasks',
    () => ({})
);

export const qualityRecieveTasks = createAction(
    'quality/recieve-tasks',
    (errortracking) => ({errortracking})
);

export const errorRecievedInstructions = createAction(
    'quality/recieve-instructions',
    (errortracking) => ({errortracking})
);

export const errorSelect = createAction(
    'quality/select',
    (error) => ({error})
);

export const errorDeselect = createAction('quality/deselect');

export const getErrorDetails = createAction(
    'quality/get-error-details',
    (uuid) => ({uuid})
);

export const storeErrorDetails = createAction(
    'quality/store-error-details',
    (details) => ({details})
);



// WEBPACK FOOTER //
// ./src/store/quality/actions.js